// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiRequest {
    static getAttributeTypeMap() {
        return MedicalBiRequest.attributeTypeMap;
    }
}
MedicalBiRequest.discriminator = undefined;
MedicalBiRequest.additionalProperties = false;
MedicalBiRequest.attributeTypeMap = [
    {
        "name": "diagnosis",
        "baseName": "diagnosis",
        "type": "MedicalBiDiagnosis"
    },
    {
        "name": "facility",
        "baseName": "facility",
        "type": "MedicalBiFacility"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "MedicalBiPatientRequest"
    },
    {
        "name": "payor",
        "baseName": "payor",
        "type": "MedicalBiPayorRequest"
    },
    {
        "name": "practice",
        "baseName": "practice",
        "type": "MedicalBiPractice"
    },
    {
        "name": "preferredSpecialtyPharmacy",
        "baseName": "preferredSpecialtyPharmacy",
        "type": "boolean"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "MedicalBiPrescriberRequest"
    },
    {
        "name": "prescription",
        "baseName": "prescription",
        "type": "MedicalBiPrescription"
    },
    {
        "name": "specialtyPharmacyName",
        "baseName": "specialtyPharmacyName",
        "type": "string"
    },
    {
        "name": "mock",
        "baseName": "mock",
        "type": "boolean"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiRequest.js.map